import React from "react";

const CourseCardMobileMock = (props) => {
  return (
    <div className="p-3 bg-white rounded-brand block shadow-sm border border-gray-200 text-gray-800 no-underline mb-3 mock">
      <div className="flex">
        <div
          style={{
            width: 86,
            height: 67,
          }}
          className="rounded-brand bg-gray-300"
        />
        <div className="flex-1">
          <div className=" flex justify-between pl-2">
            <div className="text-left font-bold text-under-base leading-snug text-gray-800">
              <div className="bg-gray-300 w-48 h-5 mb-1" />
              <div className="bg-gray-300 w-40 h-5" />
            </div>
          </div>
          <div className="flex justify-between text-xs mt-2 px-6">
            <span>
              <div className="bg-gray-300 w-10 h-5" />
            </span>
            <span>
              <div className="bg-gray-300 w-10 h-5" />
            </span>
            <span>
              <div className="bg-gray-300 w-10 h-5" />
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center text-left border-b border-gray-300 pb-2 my-4">
        <div
          className="rounded-full mr-3 bg-gray-300"
          style={{ height: 36, width: 36 }}
        />
        <span className="bg-gray-300 h-5 w-24" />
      </div>
      <div className="text-left mt-1 flex items-end justify-between">
        <div className="bg-gray-300 w-32 h-5" />
        <div className="bg-gray-300 w-12 h-5" />
      </div>
      <div className="text-base flex justify-between items-center mt-2">
        <div
          className="btn bg-gray-300 flex-1 px-1 leading-tight text-center"
          style={{ width: "100%", height: 36, marginRight: 15 }}
        />
        <div
          style={{ width: 46, height: 36, padding: 0 }}
          className="bg-gray-300 btn"
        />
      </div>
    </div>
  );
};

export default CourseCardMobileMock;
